import Layout from "../../components/global/layout";
import Table from "../../components/table";
import SelectDropdown from "../../components/common/SelectDropdown";
import moment from "moment";
import { Tooltip } from "antd";
import { PiEyeLight } from "react-icons/pi";
import { SlCalender } from "react-icons/sl";
import DatePicker from 'react-datepicker';

const Html = ({
  filter,
  pageChange,
  count,
  clear,
  filters,
  data,
  total = { total },
  handleSearch,
  changestatus,
  getData,
  view,
  setDateRange,
  startDate,
  endDate,
}) => {

  const columns = [
    {
      key: "createdAt",
      name: "Date",
      render: (row) => {
        return (
          <span className="">
            {moment(row?.createdAt).format("DD MMM, YYYY")}
          </span>
        );
      },
    },
    {
      key: "userDetail?.fullName",
      name: "Sender Name",
      render: (row) => {
        return (
          <p className="capitalize">{row?.userDetail?.fullName}</p>
        );
      },
    },
    {
      key: "userDetail?.email",
      name: "Sender Email",
      render: (row) => {
        return (
          <p>{row?.userDetail?.email}</p>
        );
      },
    },
    {
      key: "cardDetails",
      name: "Total Cards",
      render: (row) => {
        return (
          <p>{row?.cardDetails?.length || 0}</p>
        );
      },
    },
    {
      key: "IncludingTaxAmount",
      name: "Amount",
      render: (row) => {
        return (
          <p>${row?.isPromo === "yes" ? row?.discountedAmount : row?.IncludingTaxAmount || row?.totalAmount || 0}</p>
        );
      },
    },
    {
      key: "transaction_status",
      name: "Status",
      render: (row) => {
        return (
          <>
            <div className="w-32">
              <span className={`cursor-pointer text-sm !px-3 h-[30px] w-[100px] cursor-pointer flex items-center justify-center border border-[#EBEBEB] text-[#fff] !rounded capitalize ${row?.transaction_status === "successful" ? "bg-[#F58D18]" : "bg-gray-200 text-black"}`}>
                {row?.transaction_status}
              </span>
            </div>
          </>
        );
      },
    },
    {
      key: "action",
      name: "Actions",
      render: (itm) => {
        return (
          <>
            <div className="flex items-center justify-start gap-1.5">
              <Tooltip placement="top" title="View">
                <p onClick={(e) => view(itm?.id || itm?._id)} className="border cursor-pointer hover:opacity-70 rounded-lg bg-[#F58D1814] w-10 h-10 !text-primary flex items-center justify-center text-lg">
                  <PiEyeLight />
                </p>
              </Tooltip>
            </div>
          </>
        );
      },
    },
  ];

  const handleDateRangeFilter = (date) => {
    setDateRange(date)
    if (date?.[0] && date?.[1] || !date?.[0] && !date?.[1]) {
      const start = date?.[0] ? moment(date?.[0]).format("YYYY-MM-DD") : ""
      const end = date?.[1] ? moment(date?.[1]).format("YYYY-MM-DD") : ""
      getData({ startDate: start, endDate: end })
    }
  }

  return (
    <Layout>
      <div className="flex flex-wrap justify-between items-center gap-y-4">
        <h3 className="text-2xl font-semibold text-[#111827]">Transactions</h3>
      </div>
      <div className="shadow-box w-full bg-white rounded-lg mt-6">
        <div className="flex p-4 items-center flex-wrap">
          <form
            className="flex items-center max-w-sm"
            onSubmit={(e) => { e.preventDefault(); filter(); }}
          >
            <label htmlFor="simple-search" className="sr-only">
              Search
            </label>
            <div className="relative w-full">
              <input
                type="text"
                id="simple-search"
                value={filters?.search}
                onChange={(e) => handleSearch(e)}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-orange-500 focus:border-[#F58D18] block w-full ps-10 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-orange-500 dark:focus:border-orange-500 pr-10"
                placeholder="Search"
                required
              />
              {filters?.search && (
                <i
                  className="fa fa-times absolute right-4 top-1/2 -translate-y-1/2 text-gray-500 text-sm"
                  aria-hidden="true"
                  onClick={(e) => clear()}
                ></i>
              )}
            </div>
            <button
              type="submit"
              className="p-2.5 m-2 text-sm font-medium text-[#222222d6] bg-blue-700 rounded-lg border border-[#F58D18] focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
            >
              <svg
                className="w-4 h-4"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 20 20"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                />
              </svg>
              <span className="sr-only">Search</span>
            </button>
          </form>
          <div className="flex gap-2 ml-auto">
            <div className="date_picker relative">
              <DatePicker
                selectsRange={true}
                startDate={startDate}
                endDate={endDate}
                className="capitalize inline-flex w-full border justify-start h-10 gap-x-1.5 rounded-md bg-white px-3 py-2.5 text-lg font-medium text-black shadow-sm"
                onChange={(update) => handleDateRangeFilter(update)}
                isClearable={true}
                placeholderText="Select Date Range"
              />
              <SlCalender className="absolute top-1/2 left-0 transform -translate-y-1/2 p-[6px] text-gray-400 text-[30px]" />
            </div>
            <SelectDropdown
              id="statusDropdown"
              displayValue="name"
              placeholder="All Status"
              intialValue={filters?.transaction_status}
              result={(e) => { changestatus(e.value, "transaction_status") }}
              options={[
                { id: "pending", name: "Pending" },
                { id: "successful", name: "Successful" },
              ]}
            />
            {filters?.transaction_status &&
              <button className="bg-primary leading-10 h-10 inline-block shadow-btn px-6 hover:opacity-80 text-sm text-white rounded-lg" onClick={() => clear()}>
                Reset
              </button>
            }
          </div>
        </div>
        <>
          <Table
            className="mb-3"
            data={data}
            columns={columns}
            page={filters.page}
            count={filters.count}
            filters={filters}
            total={total}
            result={(e) => {
              if (e.event === "page") pageChange(e.value);
              if (e.event === "count") count(e.value);
            }}
          />
        </>
      </div>
    </Layout>
  );
};

export default Html;